import { buildContactMailtoUrl, CONTACT_EMAIL } from '@/constants/contact'
import { STORE_INFO } from '@/constants/store-info'
import { lerp, smoothstep01 } from '@/lib/utils/math'

const EYEBROW_TEXT = 'O Ateliê'
const WORDMARK_TEXT = 'Flora Ateliê'
const CONTACT_HEADING_TEXT = 'Fale com o ateliê por e-mail'
const HOURS_NOTE = 'Confirme o horário e a entrega por e-mail.'
const CONTACT_LABEL = 'Encomendar flores'
const TRIGGER_TEXT = 'Resposta pelo e-mail do ateliê — sem cadastro.'

const ENTER_END = 0.34
const INTERACTIVE_THRESHOLD = 0.4

export interface FinaleSectionModelProps {
  progress: number
}

export function useFinaleSectionModel({ progress }: FinaleSectionModelProps) {
  const enter = smoothstep01(progress / ENTER_END)

  return {
    eyebrowText: EYEBROW_TEXT,
    wordmarkText: WORDMARK_TEXT,
    contactHeadingText: CONTACT_HEADING_TEXT,
    slogan: STORE_INFO.slogan,
    deliveryLine: `Entrega em ${STORE_INFO.deliveryArea}`,
    hoursLine: `${STORE_INFO.hoursWeekdays} · ${STORE_INFO.hoursSunday}`,
    hoursNote: HOURS_NOTE,
    contactEmail: CONTACT_EMAIL,
    contactEmailHref: buildContactMailtoUrl(),
    contactLabel: CONTACT_LABEL,
    triggerText: TRIGGER_TEXT,
    stageInert: progress <= INTERACTIVE_THRESHOLD,
    stageStyle: {
      opacity: Math.round(enter * 1000) / 1000,
      pointerEvents:
        progress > INTERACTIVE_THRESHOLD
          ? ('auto' as const)
          : ('none' as const),
    },
    contentStyle: {
      transform: `translate3d(0, ${lerp(28, 0, enter).toFixed(2)}px, 0)`,
    },
  }
}
